import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { RequestSelect } from '../RequestSelect'

function RequestSelectFormikField({ Select = RequestSelect, ...restProps }) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default RequestSelectFormikField
